import { makeStyles } from '@material-ui/styles';
import { MenuLine, Theme } from '@bizzabo/design-system';

const TriggerActionsMenu = ({ isOpen }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <MenuLine className={isOpen && 'icon'} />
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    (theme: Theme) => ({
        container: {
            '& .icon': {
                color: theme.palette.greys['700'],
            },
            '&:hover': {
                color: theme.palette.greys['700'],
            },
            color: theme.palette.greys['400'],
        },
    }),
    {
        classNamePrefix: TriggerActionsMenu.name,
    }
);

export default TriggerActionsMenu;
